import { render } from "./ContentDoubtsList.vue?vue&type=template&id=3f3afec8&scoped=true&ts=true"
import script from "./ContentDoubtsList.vue?vue&type=script&lang=ts"
export * from "./ContentDoubtsList.vue?vue&type=script&lang=ts"

import "./ContentDoubtsList.vue?vue&type=style&index=0&id=3f3afec8&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3afec8"]])

export default __exports__